export default (function (nodeA, nodeB) {
    // Get the bounding rectangle of nodes
    var rectA = nodeA.getBoundingClientRect();
    var rectB = nodeB.getBoundingClientRect();
    return rectA.left + rectA.width / 2 < rectB.left + rectB.width / 2;
});
